<template>
  <main class="main__simple simple">
        <div class="breadcrumb__block contact__breadcrumbs">
        <router-link to="/" >
          <p v-text="$store.getters.pages._.meta_title" /> 
        </router-link>  
          <p class="breadcrumb__title" v-text="page.title" />
       
        </div>  
    <div class="simple__container container container--l">
      <h1 v-text="page.title" />
      <article class="simple__contacts contacts">
        <section class="contacts__section" v-for="(block, b) in page.blocks"
          :key="b">
          <div :class="['contacts__block', 'contacts__block--'+b]" :style="{backgroundColor:block.color}">
            <div :class="['contacts__media', 'contacts__media--'+b]">
              <img :class="['contacts__image', 'contacts__image--'+b]" :src="mediaPath(block.image)" :alt="$store.getters.page.title + ' ' + b" :title="$store.getters.page.title + ' ' + b">
            </div>
            <div class="contacts__title">
              <h4 v-text="block.title" />
            </div>
            <div class="contacts__info" v-html="block.info" />
            <div class="contacts__branches" v-if="block.branches.length">
              <div class="contacts__branch branch" v-for="(branch, r) in block.branches"
                :key="r">
                <h5 v-text="branch.title" />
                <div class="branch__rows">
                  <template v-if="branch.phones" v-for="(phone, p) in branch.phones" >
                    <div class="branch__row" :key="p">
                      <span class="branch__label" v-if="p===0" v-text="ui.phones_label"
                      />
                      <a class="branch__link branch__link--phone" :href="'tel:'+phone"
                        v-text="phone" />
                      <span class="branch__comma" v-if="p!==branch.phones.length-1"
                        v-text="','" />
                    </div>
                  </template>
                  <div class="branch__row" v-if="branch.fax">
                    <span class="branch__label" v-text="ui.fax_label" />
                    <span class="branch__text" v-text="branch.fax" />
                  </div>
                  <div class="branch__row" v-if="branch.mobile">
                    <span class="branch__label" v-text="ui.mobile_label" />
                    <a class="branch__link branch__link--phone" :href="'tel:'+branch.mobile"
                      v-text="branch.mobile" />
                  </div>
                  <div class="branch__row" v-if="branch.email">
                    <a class="branch__link branch__link--email" :href="'mailto:'+branch.email"
                      v-text="branch.email" />
                  </div>
                </div>
              </div>
            </div>
            <div class="contacts__map-trigger more" @click="handleMap(block.mapLng, block.mapLat)">
              <span class="more__text" v-text="ui.view_map" />
              <i class="more__arrow" />
            </div>
          </div>
        </section>
      </article>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import page from '@/mixins/page'

export default {
  mixins: [page],
  name: 'Contacts',
  computed: {
    ...mapGetters(['activeModal'])
  },
  methods: {
    ...mapActions(['openModal', 'openMap']),
    handleMap(lat, lng) {
      this.openMap({ lat, lng })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/ContactsTemplate.vue